const LOGIN_PATH = "/login";

type LocationParts = Pick<Location, "pathname" | "search" | "hash">;

export const getCurrentAppPath = ({ pathname, search, hash }: LocationParts): string =>
  `${pathname}${search}${hash}`;

export const createExpiredLoginPath = (returnTo: string): string => {
  const searchParams = new URLSearchParams({ expired: "true", returnTo });

  return `${LOGIN_PATH}?${searchParams.toString()}`;
};

export const getSafeReturnPath = (returnTo: string | null | undefined): string | undefined => {
  if (!returnTo?.startsWith("/") || returnTo.startsWith("//")) {
    return undefined;
  }

  const destination = new URL(returnTo, window.location.origin);

  if (destination.origin !== window.location.origin || destination.pathname === LOGIN_PATH) {
    return undefined;
  }

  return `${destination.pathname}${destination.search}${destination.hash}`;
};
